/**
 * ローディング画面のステップ定義
 * 各機能のAI処理中に段階的に表示するメッセージと時間を管理
 */

export const LOADING_STEPS = {
  // 採用計画アシスタント（初回生成）
  recruit_plan: {
    steps: [
      {
        message: '要件を分析中...',
        duration: 10000  // 10秒
      },
      {
        message: '最適な採用戦略を計算中...',
        duration: 18000  // 18秒
      },
      {
        message: 'タイムラインを作成中...',
        duration: 12000  // 12秒
      },
    ],
    totalEstimate: 40,  // 秒
  },

  // 採用計画アシスタント（再生成）
  recruit_plan_regenerate: {
    steps: [
      {
        message: 'フィードバックを解析中...',
        duration: 7000  // 7秒
      },
      {
        message: '採用計画を再構築中...',
        duration: 22000  // 22秒
      },
      {
        message: '変更点を最適化中...',
        duration: 10000  // 10秒
      },
    ],
    totalEstimate: 39,
  },

  // 募集媒体選定（初回）
  media_selection: {
    steps: [
      {
        message: '媒体データベースを検索中...',
        duration: 7000  // 7秒
      },
      {
        message: '最適な媒体を分析中...',
        duration: 14000  // 14秒
      },
      {
        message: '推奨プランを作成中...',
        duration: 12000  // 12秒
      },
    ],
    totalEstimate: 33,
  },

  // 募集媒体選定（再選定）
  media_selection_regenerate: {
    steps: [
      {
        message: '修正内容を確認中...',
        duration: 6000  // 6秒
      },
      {
        message: '媒体選定を再計算中...',
        duration: 18000  // 18秒
      },
      {
        message: '新しいプランを仕上げ中...',
        duration: 10000  // 10秒
      },
    ],
    totalEstimate: 34,
  },

  // 求人票自動作成（初回）
  job_posting: {
    steps: [
      {
        message: '企業情報を取得中...',
        duration: 6000  // 6秒
      },
      {
        message: 'AIが求人票を執筆中...',
        duration: 22000  // 22秒
      },
      {
        message: '最終調整中...',
        duration: 10000  // 10秒
      },
    ],
    totalEstimate: 38,
  },

  // 求人票自動作成（再生成）
  job_posting_regenerate: {
    steps: [
      {
        message: '修正指示を解析中...',
        duration: 6000  // 6秒
      },
      {
        message: '求人票を書き直し中...',
        duration: 18000  // 18秒
      },
      {
        message: '内容を洗練中...',
        duration: 8000  // 8秒
      },
    ],
    totalEstimate: 32,
  },

  // 面接チェックシート生成
  interview_checksheet: {
    steps: [
      {
        message: '候補者情報を分析中...',
        duration: 6000  // 6秒
      },
      {
        message: '面接質問を生成中...',
        duration: 14000  // 14秒
      },
      {
        message: 'チェックシートを作成中...',
        duration: 10000  // 10秒
      },
    ],
    totalEstimate: 30,
  },

  // 面接評価
  interview_evaluate: {
    steps: [
      {
        message: '回答内容を分析中...',
        duration: 6000  // 6秒
      },
      {
        message: '総合評価を算出中...',
        duration: 10000  // 10秒
      },
      {
        message: 'レポートを作成中...',
        duration: 6000  // 6秒
      },
    ],
    totalEstimate: 22,
  },

  // 次の面接生成
  interview_next_stage: {
    steps: [
      {
        message: '前回の評価を確認中...',
        duration: 6000  // 6秒
      },
      {
        message: '次段階の質問を生成中...',
        duration: 14000  // 14秒
      },
      {
        message: '新しいチェックシートを準備中...',
        duration: 7000  // 7秒
      },
    ],
    totalEstimate: 27,
  },

  // デフォルト（機能が指定されていない場合）
  default: {
    steps: [
      {
        message: '処理を開始中...',
        duration: 10000  // 10秒
      },
      {
        message: 'AIが作業中...',
        duration: 18000  // 18秒
      },
      {
        message: 'もうすぐ完了します...',
        duration: 10000  // 10秒
      },
    ],
    totalEstimate: 38,
  },
};
